/**
 * @file Created on Wed Aug 29 2018
 * @author SKu
 */
import CheckBoxGroup, { CheckBoxGroupValidated } from './CheckBoxGroup';
export default CheckBoxGroup;
export { CheckBoxGroupValidated };